import { render, staticRenderFns } from "./form_part.vue?vue&type=template&id=72b7f774&scoped=true&"
import script from "./form_part.vue?vue&type=script&lang=js&"
export * from "./form_part.vue?vue&type=script&lang=js&"
import style0 from "./form_part.vue?vue&type=style&index=0&id=72b7f774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b7f774",
  null
  
)

export default component.exports